export default __webpack_public_path__ + "static/media/loreal.8e746bf9.svg";